import { useStoreCountry } from './useStoreCountry';
import { countryToContractLocale, type ContractLocale } from '../shared/supported-languages';

/**
 * Maps the store's country from configuration to a contract locale (e.g. EN_US, PL_PL).
 * Use when defaulting contract language from the store's country (e.g. in SaleForm contract step).
 * @returns Contract locale string, or 'EN_US' if store country is not set or not mappable.
 */
export function useStoreContractLocale(): ContractLocale {
  const storeCountry = useStoreCountry();
  return countryToContractLocale(storeCountry);
}
